import './styles/style.scss';

// import './scripts/customizer';
import './scripts/skip-link-focus-fix';
import './scripts/navigation';
import './scripts/report';
import './scripts/sidebar';

import './scripts/site';